import React, { useState } from 'react';
import styles from '../css/bg.module.css';
import { Typography, TextField, Button } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { userSignedIn } from '../selectors';
import {
    emailPasswordSignin,
    authError,
    emailPasswordRegister,
    linkAccount,
} from '../actions/userActions';
import { Link, Redirect } from 'react-router-dom';

const Signin = ({ mode, history, location }) => {
    const signedIn = useSelector((state) => userSignedIn(state));
    // can't use selector bc it doesn't detect change in object property
    const user = useSelector((state) => state.user);
    var anonymous = user && user.isAnonymous;

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const dispatch = useDispatch();

    const { from } = location.state || { from: { pathname: '/liquors' } };

    if (signedIn && !anonymous) {
        return <Redirect to={from} />;
    }

    const handleSubmit = () => {
        if (mode === 'signin') {
            dispatch(emailPasswordSignin(email, password));
        } else if (mode === 'register') {
            if (confirmPassword !== password) {
                dispatch(
                    authError({
                        message: "confirm password doesn't match password",
                    })
                );
                setConfirmPassword('');
            } else {
                if (location.state && location.state.linkAccount) {
                    dispatch(linkAccount(email, password, history, from));
                } else {
                    dispatch(
                        emailPasswordRegister(email, password, history, from)
                    );
                }
            }
        }
    };

    return (
        <div className={styles.bg}>
            <div className={styles.center}>
                <Typography variant="h1">
                    {mode === 'signin' ? 'Sign In' : 'Sign Up'}
                </Typography>
                <div style={{ marginLeft: '1rem', marginRight: '1rem' }}>
                    <form>
                        <TextField
                            variant="standard"
                            type="email"
                            color="primary"
                            label="email"
                            value={email}
                            onChange={(event) => {
                                setEmail(event.target.value);
                            }}
                            style={{
                                marginTop: '2rem',
                                width: '100%',
                            }}
                        />
                        <TextField
                            variant="standard"
                            type="password"
                            color="primary"
                            label="password"
                            value={password}
                            onChange={(event) => {
                                setPassword(event.target.value);
                            }}
                            fullWidth
                            style={{
                                marginTop: '1rem',
                                boxSizing: 'border-box',
                                width: '100%',
                            }}
                        />
                        {mode === 'register' && (
                            <TextField
                                variant="standard"
                                type="password"
                                color="primary"
                                label="confirm password"
                                value={confirmPassword}
                                onChange={(event) => {
                                    setConfirmPassword(event.target.value);
                                }}
                                fullWidth
                                style={{
                                    marginTop: '1rem',
                                    boxSizing: 'border-box',
                                    width: '100%',
                                }}
                            />
                        )}
                        <Button
                            variant="contained"
                            onClick={handleSubmit}
                            style={{ marginTop: '3rem' }}
                        >
                            Submit
                        </Button>
                    </form>

                    <div style={{ marginTop: '1rem' }}>
                        {mode === 'register' ? (
                            <Link
                                className={styles.link}
                                to={{
                                    pathname: '/signin',
                                    state: {
                                        from: location.state
                                            ? location.state.from
                                            : '/liquors',
                                    },
                                }}
                            >
                                Have an account? Sign in.
                            </Link>
                        ) : (
                            <Link
                                className={styles.link}
                                to={{
                                    pathname: '/register',
                                    state: {
                                        from: location.state
                                            ? location.state.from
                                            : '/liquors',
                                    },
                                }}
                            >
                                Don't have an account? Register
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Signin;
